export default {
  p3: {
    getTheme: () => import('@/router/theme_a'),
    skins: {
      default: 'dark_green',
      dark_green: () => import('@a/skins/dark_green.scss'),
      // xxx: () => import('@b/skins/dark_gold.scss'),
    }
  },

  p4: {
    getTheme: () => import('@/router/theme_b'),
    skins: { 
      default: 'dark_gold',
      dark_gold: () => import('@b/skins/dark_gold.scss'),
      // xxx: () => import('@a/skins/dark_green.scss')
    }
  },
  
  default: 'p4'
}
